<template>
      <div class="classroomCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'classroom', params: {} }">
          Classroom
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'classroomCreate', params: {} }">
            Create Classroom
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Classroom</v-card-title>
          <v-card-text>
            <classroom-form></classroom-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import ClassroomForm from './ClassroomForm.vue';

    export default {
      name: 'classroom',
      components: {
        ClassroomForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    